/**
 * Phase 129 (Plan 129-05) — the Engineering tab's cards container.
 *
 * A vertical stack of cards, each saving on its own: Repositories, Robot, Repository policies and
 * Release flags (the last renders only when the project has flags).
 */
import type { ReactElement } from 'react';
import { ProjectRepositoriesCard } from './ProjectRepositoriesCard';
import { ProjectPoliciesCard } from './ProjectPoliciesCard';
import { ProjectReleaseFlagsCard } from './ProjectReleaseFlagsCard';
import { ProjectRobotCard } from './ProjectRobotCard';

export interface ProjectEngineeringTabProps {
  projectId: number;
}

export function ProjectEngineeringTab({ projectId }: ProjectEngineeringTabProps): ReactElement {
  return (
    <div className="space-y-6" data-testid="project-engineering-tab">
      <ProjectRepositoriesCard projectId={projectId} />
      <ProjectRobotCard projectId={projectId} />
      <ProjectPoliciesCard projectId={projectId} />
      <ProjectReleaseFlagsCard projectId={projectId} />
    </div>
  );
}

export default ProjectEngineeringTab;
